export default __webpack_public_path__ + "static/media/eye-off.623c17dd.svg";